import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpUrlGenerator, DefaultDataServiceConfig } from '@ngrx/data';
import { Store } from '@ngrx/store';
import { LoggingService } from '../../../shared/services/logging/logging.service';
import { EfaactDataService } from '../../efaact.data-service';
import { ReconciliationTemplateModel } from './reconciliation-template.model';
import * as data from './MOCK_DATA.json';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

export const entityName = 'ReconciliationTemplate';
@Injectable()
export class ReconciliationTemplateDataService extends EfaactDataService<ReconciliationTemplateModel> {
    constructor(
        http: HttpClient,
        httpUrlGenerator: HttpUrlGenerator,
        log: LoggingService,
        config: DefaultDataServiceConfig,
        store: Store
    ) {
        super(http, httpUrlGenerator, entityName, log, config, store);
        this.log.verbose({
            type: `${this.entityName}DataService(ReconciliationTemplateDataService)::`
        });
    }

    mapItems(item: any): ReconciliationTemplateModel {
        this.log.verbose({
            type: `${this.entityName}DataService(ReconciliationTemplateDataService):mapItems`,
            item
        });
        return { Name: item.TemplateName, id: item.TemplateName } as any;
        // return item;
        // this.log.verbose({
        //     type: `${this.entityName}DataService(ReconciliationTemplateDataService):mapItems`,
        //     item
        // });
        // return { ...item, id: item.Fieldname };
    }
    getAll(): Observable<ReconciliationTemplateModel[]> {
        // return of([]);
        this.log.verbose({
            type: `${this.entityName}DataService(ReconciliationTemplateDataService):getAll`,
            data: (data as any).default
        });
        return of((data as any).default).pipe(
            map(items => items.map(p => this.mapItems(p)))
        );
    }
}
